



























































































































































































import { Toast, Swipe, SwipeItem } from "vant";
import { Component, Vue } from "vue-property-decorator";
import request from "@/api/index";
import { INews } from "@/api/types";
import NewsItem from "@/components/newsItem/Index.vue";
import { ColumnInfo } from "@/common/baseConfig";
import { wxChatShare } from "@/common/wechat";
import { isWeiXin } from "@/common/utils";
@Component({
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "news-item": NewsItem
  }
})
export default class Home extends Vue {
  current = 0;
  niceCurrent = 0;
  planCurrent = 0;

  /** 滚动数据列表 */
  roleList: INews[] = [];

  /** 精彩图集列表 */
  niceList: INews[] = [];

  /** 视频新闻列表 */
  videoList: INews[] = [];

  /** 融媒策划列表 */
  planSwipeList: INews[] = [];
  planNewsList: INews[] = [];

  /** 外媒聚焦轮播列表 */
  focusSwipeList: INews[] = [];

  /** 外媒聚焦新闻列表 */
  focusList: INews[] = [];

  info = {
    shareTitle: "【专题】聚焦2021年綦江两会",
    shareSynopsis: "确保在社会主义现代化建设新征程中“开好局、起好步”",
    shareImgUrl:
      "http://h5cloud.cqliving.com/zwy/qjlianghui/img/20210304145934.jpg",
    shareLink: window.location.href
  };

  created() {
    /** 注册微信分享 */
    if (isWeiXin()) {
      wxChatShare(
        this.info.shareTitle,
        this.info.shareSynopsis,
        this.info.shareLink,
        this.info.shareImgUrl
      );
    }
  }

  mounted() {
    this.getRollList();
    this.getNiceList();
    this.getVideoList();
    this.getPlanList();
    this.getFocusList();
  }

  /** 滚动新闻 */
  async getRollList() {
    const data = await this.getNewsList(ColumnInfo.滚动新闻);
    if (data!.news.length > 3) {
      this.roleList = data!.news.splice(0, 3);
    } else {
      this.roleList = data!.news;
    }
  }

  /** 精彩图集 */
  async getNiceList() {
    const data = await this.getNewsList(ColumnInfo.精彩图集);
    this.niceList = data!.carousels;
  }

  /** 视频新闻 */
  async getVideoList() {
    const data = await this.getNewsList(ColumnInfo.视频新闻);
    if (data?.news && data?.news.length > 4) {
      this.videoList = data?.news.splice(0, 4);
    } else {
      this.videoList = data!.news;
    }
  }

  /** 融媒策划 */
  async getPlanList() {
    const data = await this.getNewsList(ColumnInfo.融媒策划);
    this.planSwipeList = data!.carousels;
    this.planNewsList = data!.news;
  }

  /** 外媒聚焦 */
  async getFocusList() {
    const data = await this.getNewsList(ColumnInfo.外媒聚焦);
    this.focusSwipeList = data!.carousels;
    if (data?.news && data?.news.length > 2) {
      this.focusList = data?.news.splice(0, 2);
    } else {
      this.focusList = data!.news;
    }
  }

  /** 获取新闻列表 */
  async getNewsList(columnId: number) {
    const result = await request.getInfoList(columnId);
    if (!result.code) {
      return result.data;
    }
  }

  /** 跳转列表页 */
  checkMore(flag: string) {
    if (flag === "video") {
      this.$router.push("video-list");
    } else if (flag === "plan") {
      this.$router.push({
        path: "news-list",
        query: {
          flag: "plan"
        }
      });
    } else if (flag === "focus") {
      this.$router.push({
        path: "news-list",
        query: {
          flag: "focus"
        }
      });
    }
  }

  onNiceChange(index: number) {
    this.niceCurrent = index;
  }

  onChange(index: number) {
    this.current = index;
  }

  onPlanChange(index: number) {
    this.planCurrent = index;
  }

  /** 融媒策划 轮播控制 */
  moveSwipe(flag: string) {
    const planSwipe = this.$refs.planSwipe as Swipe;
    if (flag === "prev") {
      planSwipe.prev();
    } else {
      planSwipe.next();
    }
  }

  newsClick(data: INews) {
    window.location.href = data.url;
  }

  /** 两会特刊 */
  clickSpecial() {
    // Toast("点击两会特刊");
    window.location.href = "http://qjszb.cqqjnews.cn/m/202103/09/node_A1.html";
  }
}
